import { render } from "./Explaintb.html?vue&type=template&id=48309bc8&scoped=true&ts=true&external"
import script from "./Explaintb.ts?vue&type=script&lang=ts&external"
export * from "./Explaintb.ts?vue&type=script&lang=ts&external"

import "./Explaintb.css?vue&type=style&index=0&id=48309bc8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48309bc8"]])

export default __exports__